import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { getBeraterId } from '../../helpers/HelperFunctions';
import { getDataFromDatabase } from '../../db/api';
import Paper from '@material-ui/core/Paper';
import BackdropSpinner from '../Reusable/BackdropSpinner';
import moment from 'moment-with-locales-es6';
import { FaSignInAlt, FaSignOutAlt } from 'react-icons/fa';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paperContainer: {
    width: '80%',
    textAlign: 'center',
    padding: '20px',
    margin: 'auto',
    marginBottom: '20px',
    backgroundColor: 'rgb(65, 121, 231)',
    color: 'white',
    borderRadius: '8px',
  },
  dateRow: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: 'white',
  },
  timeRow: {
    fontSize: '40px',
    marginTop: '10px',
    color: 'white',
  },
  lastEntryRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'left',
    marginTop: '15px',
    fontSize: '18px',
  },
  entryTimeContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'left',
    marginTop: '5px',
    fontSize: '20px',
  },
  actionPaper: {
    width: '100px',
    height: '100px',
    marginTop: '20px',
    color: 'white',
    fontSize: '16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  greenBackground: {
    backgroundColor: 'green',
  },
  redBackground: {
    backgroundColor: 'red',
  }
}));

export default function Arbeitszeterfassen() {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentTime, setCurrentTime] = useState(moment().format('HH:mm:ss'));
  const [lastEntry, setLastEntry] = useState({ timeIn: null ,timeOut: null,type:'entry' });
  const [refreshTrigger, setRefreshTrigger] = useState(false);

  useEffect(() => {
    setLoading(true);
    let beraterId = getBeraterId();
    getDataFromDatabase(`api/FirmaInfo/Letztebuchung`,
      { BeraterId: beraterId },
      { method: "POST" })
      .then(res => {
        console.log("resztf", res)
        setLastEntry(res);
        setLoading(false);
      })
      .catch(() => setLoading(false));
    
    const interval = setInterval(() => {
      setCurrentTime(moment().format('HH:mm:ss'));
    }, 1000);

    return () => {
      clearInterval(interval);
      console.log("Running cleanup function !");
    }
  }, [refreshTrigger]);

  const logZeiterfassungTime = () => {
    setLoading(true);
    let beraterId = getBeraterId();
    getDataFromDatabase(`api/FirmaInfo/LogZeiterfassungTime`,
      { BeraterId: beraterId },
      { method: "POST" })
      .then(res => {
        //console.log("resztf", res)
        setLoading(false);
        setRefreshTrigger(prev => !prev); // Toggle state to trigger useEffect
      })
      .catch(() => setLoading(false));
  }

  const isAtWork = !lastEntry.timeOut;
  const buttonText = isAtWork ? "GEHEN" : "KOMMEN";
  const buttonIcon = isAtWork ? <FaSignOutAlt size={50} /> : <FaSignInAlt size={50} />;
  const buttonClass = isAtWork ? classes.redBackground : classes.greenBackground;

  return (
    <div className="wrapper">
      <div className="cards">
        <Paper variant="outlined" className={classes.paperContainer}>
          <div className={classes.dateRow}>{moment().locale('de').format('dddd, DD.MM.YYYY')}</div>
          <div className={classes.timeRow}>{currentTime}</div>
          <div className={classes.lastEntryRow}>
            <span>Letzte Buchung</span>
            {lastEntry.type === 'entry' ? <FaSignInAlt size={24} /> : <FaSignOutAlt size={24} />}
          </div>
          <div className={classes.entryTimeContainer}>
            {lastEntry.In !== null && (
              <span>{moment(lastEntry.timeIn).locale('de').format('HH:mm, DD.MM.YYYY')}</span>
            )}
            
            {lastEntry.timeOut !== null && (
              <span>{moment(lastEntry.timeOut).locale('de').format('HH:mm, DD.MM.YYYY')}</span>
            )}
            
          </div>
        </Paper>
        <Paper variant="outlined" className={`${classes.actionPaper} ${buttonClass}`} onClick={()=> logZeiterfassungTime()}>
          {buttonIcon}
          <span>{buttonText}</span>
        </Paper>
      </div>
      <BackdropSpinner showLoading={loading} />
    </div>
  );
}
